export default __webpack_public_path__ + "static/media/mernstore1.d04e5d74.png";